/**
 * The examples text fields show as their placeholder, the same words on the web, Android,
 * iOS and the Windows agent. Each is a short value the field rules accept, written exactly
 * as it would be typed: no "e.g.", no full stop. A placeholder sits beside the visible label
 * and never replaces it, and it never holds a hint. Password fields show no example
 * password: a new password says what it needs, a sign-in password says whose it is.
 * examples.test.ts checks every example against the field rules.
 */
export const EXAMPLE = {
  email: "name@company.com",
  personName: "Asha Rao",
  employeeId: "EMP-0007",
  companyName: "Acme Ltd",
  /** The short name a new organisation gets from "Acme Ltd". */
  slug: "acme-ltd",
  teamName: "Customer support",
  teamDescription: "Handles support for customers in Europe",
  jobRoleName: "Software engineer",
  /** Days to keep screenshots, 1 to 365. */
  retentionDays: "30",
  /** Why a screenshot should be removed, 5 to 500 characters. */
  removalReason: "It shows my personal bank account",
  /** An admin's note on a rejected removal request, at most 280 characters. */
  removalNote: "The screenshot shows only the company's own documents",
  /** The code the Zotula icon shows on a computer waiting to be connected. */
  connectCode: "FGH7-KM3P",
  /** A filter box over a list of people or devices: a name or an employee ID, as typed. */
  search: "Asha Rao or EMP-0007",
  newPassword: "At least 12 characters",
  currentPassword: "Your password",
} as const;
